import React, { DOMElement, useState, useEffect } from "react";
import Commons from "oc-commons/Commons";
import CheckboxInput from "./commons/CheckboxInput";
import uiActions from "../uiActions";
import Parts from "./sidebar/overview/Parts";
import Dekore from "./sidebar/overview/Dekore";
import Helper from "../../model/Helper";
import SavedModal from "./SavedModal";

export default class SaveModal extends React.Component {
    constructor() {
        super();
        this.email = "";
    }

    getSidebarParent() {
        return null;
    }
    
    onChange(closure) {
        return (v) => {
            closure(v);
            this.forceUpdate();
        };
    }

    downloadClicked(ev) {
        uiActions.pdf();
    }

    saveClicked(ev) {
        APP.save(()=>{
            APP.uiHandler.dialog({
                title: I18N("Gespeichert titel"),
                text: I18N("Gespeichert text"),
                child: <SavedModal />,
                buttons: [
                    {
                        style: "primary",
                        label: I18N("Schließen")
                    },
                ],
            });
        }, ()=>{}, false, this.emailValid(), this.email);
    }

    copyToClipboard() {
        const fallbackCopyTextToClipboard = (text) => {
            var textArea = document.createElement("textarea");
            textArea.value = text;
            
            // Avoid scrolling to bottom
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";
          
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
          
            try {
                var successful = document.execCommand('copy');
                var msg = successful ? 'successful' : 'unsuccessful';
                console.log('Fallback: Copying text command was ' + msg);
            } catch (err) {
                console.error('Fallback: Oops, unable to copy', err);
            }
          
            document.body.removeChild(textArea);
        }

        const copyTextToClipboard = (text) => {
            if (!navigator.clipboard) {
                fallbackCopyTextToClipboard(text);
                return;
            }
            navigator.clipboard.writeText(text).then(() => {
                console.log('Async: Copying to clipboard was successful!');
            }, function(err) {
                console.error('Async: Could not copy text: ', err);
            });
        }

        APP.save((json)=>{
            copyTextToClipboard(window.location.href);
        }, ()=>{});
    }

    saveReqeust() {
        if (APP.arrangement.kunde.isValid) {
            APP.save(
                () => {
                    APP.uiHandler.ui.hideModal();
                }, 
                () => {
                    console.error("saving failed")
                }, 
                true
            );

            // if (checked) {
            // APP.save(APP.arrangement.kunde, values, "Bei Hersteller bestellt");
            // } else {
            // APP.save(APP.arrangement.kunde, values, "Bei Händler bestellt");
            // }
        }
    }

    emailValid() {
        console.log(this.email);
        return this.email?.indexOf("@") > 0
            && this.email?.length >= 3;
    }

    
    renderBody() {
        //TODO: SETTINGS!
        // return (<button className="button primary big-button"
        // onClick={() => this.saveClicked()} href="#">{I18N("Speichern")}</button>)
        
        const admin = APP.settings.userRole == "admin";
        const adminAndInsipration = admin && APP.configuration.Inspiration;

        return (
            <div id="stammdatenDialog" className="appear">
                <div className="spacer-before">
                    <dl>
                        <dt>{I18N("Maße:")}</dt>
                        <dd>
                            {APP.arrangement.schraenke
                                .map(
                                    (schrank) =>
                                        Helper.formatToRulerUnit(schrank.size.x) +
                                        " x " +
                                        Helper.formatToRulerUnit(schrank.size.y) +
                                        " x " +
                                        Helper.formatToRulerUnit(schrank.size.z)
                                )
                                .reduce((akku, curr, index) => (
                                    <React.Fragment key={index}>
                                        {" "}
                                        {akku} <br /> {curr}{" "}
                                    </React.Fragment>
                                ))}
                        </dd>
                        <dt>{I18N("Elemente:")}</dt>
                        <dd>
                            {APP.arrangement.schraenke
                                .map((schrank) => schrank.elements.length)
                                .reduce((akku, curr, index) => (
                                    <React.Fragment key={index}>
                                        {" "}
                                        {akku} <br /> {curr}{" "}
                                    </React.Fragment>
                                ))}
                            <br />
                        </dd>
                        <Parts arrangement={APP.arrangement} lookUpKey={"Einbauten"} label={"Ausstattung:"} />
                        <Parts arrangement={APP.arrangement} lookUpKey={"Türen"} label={"Türen:"} />
                        <Dekore arrangement={APP.arrangement} />
                        <Parts arrangement={APP.arrangement} lookUpKey={"Griffe"} label={"Griffe:"} />
                    </dl>
                </div>

                <div className="input-wrapper" style={{display: "flex"}}>
                    <input type="text" className="form-control" id="outlined-email"
                        value={this.email}
                        onChange={this.onChange((v) => (this.email = v.target?.value))}
                        placeholder={I18N("Email")}
                        style={{
                            width: "100%"
                        }}
                    />
                </div>

                {/* TODO: VLL */}
                {admin && (
                    <div className="text-left">
                        <hr></hr>
                        <p>Admin Panel</p>
                        <CheckboxInput
                            id={"inspiration"}
                            label={I18N("toInspiration")}
                            value={APP.toInspiration}
                            onChange={this.onChange((v) => (APP.toInspiration = v))}
                        />
                        <hr></hr>
                    </div>
                )}

                <div style={{display: "flex"}}>                    
                    {APP.settings.customerPDF && (
                        <button 
                            className="button primary big-button"
                            onClick={() => this.downloadClicked()} 
                            href="#"
                        >
                            {I18N("PDF")}
                        </button>
                    )}

                    <button
                        className="button primary big-button"
                        onClick={() => this.saveClicked()}
                        href="#"
                    >
                        {I18N("Speichern")}
                    </button>
                </div>
            </div>
        );
    }

    render() {
        return (
            <aside id="scroll-sidebar" className="sidebar stammdaten">
                    <div className="sidebar-body">{this.renderBody()}</div>
                <div className={" " + (Commons.isEmpty(this.getSidebarParent()) ? "only-mobile " : "")}>
                    <button className="primary finished-button" onClick={() => APP.uiHandler.sidebar(this.getSidebarParent())} href="#">
                        {I18N("Fertig")}
                    </button>
                </div>
            </aside>
        );
    }
}
